module.exports = __webpack_public_path__ + "static/media/uploadEmployeeTemplate.a954413d.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/downloads/uploadEmployeeTemplate.xlsx
// module id = 2302
// module chunks = 0